// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import UserOutlined from '/Users/higlx/work/wwwroot/qin360/agent.com/node_modules/@ant-design/icons/es/icons/UserOutlined';
import SmileOutlined from '/Users/higlx/work/wwwroot/qin360/agent.com/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import UnorderedListOutlined from '/Users/higlx/work/wwwroot/qin360/agent.com/node_modules/@ant-design/icons/es/icons/UnorderedListOutlined';
import DollarOutlined from '/Users/higlx/work/wwwroot/qin360/agent.com/node_modules/@ant-design/icons/es/icons/DollarOutlined';
import TeamOutlined from '/Users/higlx/work/wwwroot/qin360/agent.com/node_modules/@ant-design/icons/es/icons/TeamOutlined';
export default { UserOutlined, SmileOutlined, UnorderedListOutlined, DollarOutlined, TeamOutlined };
